import React from 'react';
import { CircularProgress } from '@mui/material';

// MUI Icons
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface DeleteConfirmationModalProps {
  open: boolean;
  handleClose: () => void;
  onDelete: () => Promise<void>;
  isDeleting: boolean;
  runName?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  open,
  handleClose,
  onDelete,
  isDeleting,
  runName,
}) => {
  if (!open) return null;

  return (
    <div
      className='modal-overlay'
      onClick={handleClose}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        className='modal-cont'
        style={{
          width: '540px',
          maxWidth: '90vw',
          padding: 0,
          position: 'relative',
          top: 'auto',
          left: 'auto',
          transform: 'none',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className='modal-header-cont-temp'
          style={{
            padding: '24px',
            borderBottom: '1px solid var(--es-soft-border)',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
              alignItems: 'flex-start',
            }}
          >
            <div className='modal-header-cont-text'>
              <h1
                className='modal-header-cont-text-h1'
                style={{
                  fontSize: '20px',
                  marginBottom: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <WarningAmberIcon style={{ color: '#f04438' }} /> Delete
                Analysis Run
              </h1>
              <p className='modal-header-cont-text-p' style={{ margin: 0 }}>
                Are you sure you want to delete this run?
              </p>
            </div>
            <div
              className='module-header-btn-close'
              onClick={handleClose}
              style={{ cursor: 'pointer', color: 'var(--text-secondary)' }}
            >
              <CloseIcon />
            </div>
          </div>
        </div>

        {/* Body */}
        <div
          className='modal-body'
          style={{
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          <p
            style={{
              margin: 0,
              color: 'var(--text-primary-color)',
              fontSize: '14px',
              lineHeight: '1.5',
            }}
          >
            You are about to delete the analysis run{' '}
            <strong>{runName ? `"${runName}"` : 'selected'}</strong>. This
            action cannot be undone, and all associated data, including
            generated documents and flagged discrepancies, will be permanently
            removed from the database and AWS S3 storage.
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: '24px',
            borderTop: '1px solid var(--es-soft-border)',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '12px',
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          <button
            className='btn-outline'
            onClick={handleClose}
            disabled={isDeleting}
            style={{ margin: 0, width: 'auto' }}
          >
            Cancel
          </button>
          <button
            className='btn-delete'
            disabled={isDeleting}
            onClick={onDelete}
            style={{
              margin: 0,
              width: 'auto',
              backgroundColor: '#f04438',
              borderColor: '#f04438',
              opacity: isDeleting ? 0.5 : 1,
              cursor: isDeleting ? 'not-allowed' : 'pointer',
            }}
          >
            {isDeleting ? (
              <CircularProgress size={20} color='inherit' />
            ) : (
              'Delete Run'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
